// bot-control.ts — B4b "Add Bot" client seam (pure, testable). WebAddBot (gameform.cpp:22-32) used to
// POST an external bot-control plane (window.WI_BOT_CONTROL). B4b bots are DO-resident SEATS, so the
// host's "Add Bot" button POSTs /bots/add to the SAME Durable Object the client is connected to. These
// two pure functions derive the request (no DOM/fetch — main.ts owns the fetch); the unit test drives
// them directly so the wiring is provable without a browser.

/**
 * Derive the DO's HTTP origin from the game socket's WebSocket proxy URL (ServerInfo.websocket_proxy —
 * the wss:// the client actually connected to): wss→https, ws→http, keep the host. /bots/add is a
 * same-origin route on that DO. Returns null if there is no connected URL (no game socket yet).
 */
export function botControlBase(websocketProxy: string): string | null {
  if (!websocketProxy) return null;
  try {
    const u = new URL(websocketProxy);
    u.protocol = u.protocol === 'wss:' ? 'https:' : u.protocol === 'ws:' ? 'http:' : u.protocol;
    return `${u.protocol}//${u.host}`;
  } catch {
    return null;
  }
}

/**
 * Build the full POST /bots/add URL for a staging game on the connected DO. `token` (optional) rides
 * ?token= for a prod deployment that gates the route with BOTS_TOKEN; on local/dev it is unset (the
 * route is dev-allowed with no token). Returns null if the DO base can't be derived.
 */
export function buildAddBotUrl(
  websocketProxy: string,
  roomid: number,
  gameid: number,
  token?: string,
): string | null {
  const base = botControlBase(websocketProxy);
  if (base === null) return null;
  const params = new URLSearchParams({ game: String(gameid), room: String(roomid), brain: 'easy' });
  if (token) params.set('token', token);
  return `${base}/bots/add?${params.toString()}`;
}
